 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"add-building~add-realtor~archived-leads~building-content~building-content-detail~building-details~ch~ad8ef28b":"add-building~add-realtor~archived-leads~building-content~building-content-detail~building-details~ch~ad8ef28b","add-building~add-realtor~archived-leads~building-content~building-content-detail~building-details~ch~99aa4963":"add-building~add-realtor~archived-leads~building-content~building-content-detail~building-details~ch~99aa4963","add-building":"add-building","add-realtor":"add-realtor","archived-leads~companies~companies-details~lead-details~lead-imports~leads~properties~real-estate~re~99a4bdff":"archived-leads~companies~companies-details~lead-details~lead-imports~leads~properties~real-estate~re~99a4bdff","archived-leads":"archived-leads","building-content-detail~create-post~create-realtor~edit-properties~leads~new-properties~post-detail~~70390130":"building-content-detail~create-post~create-realtor~edit-properties~leads~new-properties~post-detail~~70390130","leads":"leads","realtor-details":"realtor-details","companies":"companies","companies-details":"companies-details","lead-imports":"lead-imports","properties":"properties","real-estate":"real-estate","resources":"resources","states":"states","states-detail":"states-detail","teams":"teams","users":"users","building-content":"building-content","building-content-detail~create-building-content":"building-content-detail~create-building-content","building-content-detail":"building-content-detail","building-details":"building-details","challenge-details":"challenge-details","challenges":"challenges","lead-historic":"lead-historic","logs":"logs","posts":"posts","ranking":"ranking","ranking-detail":"ranking-detail","real-estate-detail":"real-estate-detail","realtors":"realtors","team-details":"team-details","lead-details":"lead-details","create-building-content":"create-building-content","create-post~edit-properties~new-properties~post-detail":"create-post~edit-properties~new-properties~post-detail","create-post":"create-post","details-properties~edit-properties~new-properties":"details-properties~edit-properties~new-properties","edit-properties":"edit-properties","new-properties":"new-properties","post-detail":"post-detail","create-realtor":"create-realtor","users-details":"users-details","dashboard":"dashboard","details-properties":"details-properties","new-challenge":"new-challenge","push-notification":"push-notification","realtor-historic":"realtor-historic","settings":"settings","forgot-password":"forgot-password","login":"login"}[chunkId]||chunkId) + "." + {"add-building~add-realtor~archived-leads~building-content~building-content-detail~building-details~ch~ad8ef28b":"613f7e81","add-building~add-realtor~archived-leads~building-content~building-content-detail~building-details~ch~99aa4963":"e4cbff94","add-building":"d054a426","add-realtor":"19ab01a9","archived-leads~companies~companies-details~lead-details~lead-imports~leads~properties~real-estate~re~99a4bdff":"8076cc14","archived-leads":"d5472c35","building-content-detail~create-post~create-realtor~edit-properties~leads~new-properties~post-detail~~70390130":"d38b17fb","leads":"c1a7ff69","realtor-details":"baa9c94f","companies":"5370db98","companies-details":"9719f6d3","lead-imports":"d45113a4","properties":"0c0dde0d","real-estate":"2678ca25","resources":"74bee51b","states":"ae770268","states-detail":"15c123d7","teams":"4029400e","users":"07657a64","building-content":"04ba1ceb","building-content-detail~create-building-content":"3d75984d","building-content-detail":"d09ded98","building-details":"43589303","challenge-details":"3525453b","challenges":"f97964bd","lead-historic":"4cda4427","logs":"262ff4e0","posts":"964603f8","ranking":"464ae882","ranking-detail":"5f74af0c","real-estate-detail":"8d750a8c","realtors":"baf0a5e9","team-details":"f05436b4","lead-details":"1d995dad","create-building-content":"95d09099","create-post~edit-properties~new-properties~post-detail":"a1b80099","create-post":"dab6ec47","details-properties~edit-properties~new-properties":"7eb80126","edit-properties":"382c54d6","new-properties":"5185e9ca","post-detail":"95f9c8e0","create-realtor":"a83317d7","users-details":"781124f3","dashboard":"d9d17bb3","details-properties":"f765a1b6","new-challenge":"7669ef81","push-notification":"2d8d84e6","realtor-historic":"29426157","settings":"c38535c2","forgot-password":"c2384d39","login":"7ec21d91"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"add-building~add-realtor~archived-leads~building-content~building-content-detail~building-details~ch~ad8ef28b":1,"add-building~add-realtor~archived-leads~building-content~building-content-detail~building-details~ch~99aa4963":1,"add-building":1,"add-realtor":1,"archived-leads~companies~companies-details~lead-details~lead-imports~leads~properties~real-estate~re~99a4bdff":1,"archived-leads":1,"leads":1,"realtor-details":1,"companies":1,"companies-details":1,"lead-imports":1,"properties":1,"real-estate":1,"resources":1,"states":1,"states-detail":1,"teams":1,"users":1,"building-content":1,"building-content-detail~create-building-content":1,"building-content-detail":1,"building-details":1,"challenge-details":1,"challenges":1,"lead-historic":1,"logs":1,"posts":1,"ranking":1,"ranking-detail":1,"real-estate-detail":1,"realtors":1,"team-details":1,"lead-details":1,"create-building-content":1,"create-post":1,"details-properties~edit-properties~new-properties":1,"edit-properties":1,"new-properties":1,"post-detail":1,"create-realtor":1,"users-details":1,"dashboard":1,"details-properties":1,"new-challenge":1,"push-notification":1,"realtor-historic":1,"settings":1,"forgot-password":1,"login":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"add-building~add-realtor~archived-leads~building-content~building-content-detail~building-details~ch~ad8ef28b":"add-building~add-realtor~archived-leads~building-content~building-content-detail~building-details~ch~ad8ef28b","add-building~add-realtor~archived-leads~building-content~building-content-detail~building-details~ch~99aa4963":"add-building~add-realtor~archived-leads~building-content~building-content-detail~building-details~ch~99aa4963","add-building":"add-building","add-realtor":"add-realtor","archived-leads~companies~companies-details~lead-details~lead-imports~leads~properties~real-estate~re~99a4bdff":"archived-leads~companies~companies-details~lead-details~lead-imports~leads~properties~real-estate~re~99a4bdff","archived-leads":"archived-leads","building-content-detail~create-post~create-realtor~edit-properties~leads~new-properties~post-detail~~70390130":"building-content-detail~create-post~create-realtor~edit-properties~leads~new-properties~post-detail~~70390130","leads":"leads","realtor-details":"realtor-details","companies":"companies","companies-details":"companies-details","lead-imports":"lead-imports","properties":"properties","real-estate":"real-estate","resources":"resources","states":"states","states-detail":"states-detail","teams":"teams","users":"users","building-content":"building-content","building-content-detail~create-building-content":"building-content-detail~create-building-content","building-content-detail":"building-content-detail","building-details":"building-details","challenge-details":"challenge-details","challenges":"challenges","lead-historic":"lead-historic","logs":"logs","posts":"posts","ranking":"ranking","ranking-detail":"ranking-detail","real-estate-detail":"real-estate-detail","realtors":"realtors","team-details":"team-details","lead-details":"lead-details","create-building-content":"create-building-content","create-post~edit-properties~new-properties~post-detail":"create-post~edit-properties~new-properties~post-detail","create-post":"create-post","details-properties~edit-properties~new-properties":"details-properties~edit-properties~new-properties","edit-properties":"edit-properties","new-properties":"new-properties","post-detail":"post-detail","create-realtor":"create-realtor","users-details":"users-details","dashboard":"dashboard","details-properties":"details-properties","new-challenge":"new-challenge","push-notification":"push-notification","realtor-historic":"realtor-historic","settings":"settings","forgot-password":"forgot-password","login":"login"}[chunkId]||chunkId) + "." + {"add-building~add-realtor~archived-leads~building-content~building-content-detail~building-details~ch~ad8ef28b":"442ab5a9","add-building~add-realtor~archived-leads~building-content~building-content-detail~building-details~ch~99aa4963":"eac6ca4e","add-building":"6869279e","add-realtor":"2ddea252","archived-leads~companies~companies-details~lead-details~lead-imports~leads~properties~real-estate~re~99a4bdff":"118cff85","archived-leads":"d10e12d0","building-content-detail~create-post~create-realtor~edit-properties~leads~new-properties~post-detail~~70390130":"31d6cfe0","leads":"2a4a5574","realtor-details":"523a16f8","companies":"c7c32e5b","companies-details":"33cfee8f","lead-imports":"b6a44c9a","properties":"9da7559e","real-estate":"d7a06061","resources":"0d67be61","states":"1913bffc","states-detail":"5a3370f6","teams":"340de49c","users":"32bd9232","building-content":"4cb0ef58","building-content-detail~create-building-content":"b5dbb3dd","building-content-detail":"126cd754","building-details":"71ddc0a0","challenge-details":"7a6a704e","challenges":"68a23c65","lead-historic":"89c21f5f","logs":"110d8eb4","posts":"41f2dbd0","ranking":"41df2827","ranking-detail":"beaea359","real-estate-detail":"ae9a80a0","realtors":"8d8ec9cf","team-details":"9c616236","lead-details":"6b627179","create-building-content":"2108c1ba","create-post~edit-properties~new-properties~post-detail":"31d6cfe0","create-post":"7c7edeb9","details-properties~edit-properties~new-properties":"7f10dcc6","edit-properties":"b48609c9","new-properties":"af422661","post-detail":"3ce6d8d4","create-realtor":"f5c25e17","users-details":"245081e2","dashboard":"35c6bcf1","details-properties":"ed03978d","new-challenge":"985242b5","push-notification":"34eb41af","realtor-historic":"37fb44f9","settings":"c5840d9f","forgot-password":"6dbdad40","login":"c43f092c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
